import { authSwitchRoutes } from '@isyc-react/auth/modules/base';
import { generatePath } from 'react-router-dom';
export const switchRoutes = Object.assign(Object.assign({}, authSwitchRoutes), { root: '/', bu: '/bu/:buCode', upload: '/upload' });
export const routes = Object.assign(Object.assign({}, switchRoutes), { bu: buCode => generatePath(switchRoutes.bu, { buCode }) });
